<div class="action-buttons px2 mb2 mt1">
	<button
		mat-raised-button
		type="button"
		*ngIf="hasPrevious"
		(click)="handlePrevious()"
	>
		<mat-icon>arrow_back</mat-icon>
		{{ previousLabel }}
	</button>
	<button
		mat-raised-button
		type="button"
		*ngIf="hasNext"
		(click)="handleNext()"
	>
		<mat-icon>arrow_forward</mat-icon>
		{{ nextLabel }}
	</button>
	<button
		mat-raised-button
		color="accent"
		(click)="handleSave()"
		[disabled]="disableSave || isLoading"
	>
		<mat-icon>save</mat-icon>
		{{ saveLabel }}
	</button>
	<button
		mat-raised-button
		color="primary"
		[disabled]="!completedForm || isLoading"
		(click)="handleSend()"
		*ngIf="!hideSend"
	>
		<mat-icon>send</mat-icon>
		{{ sendLabel }}
	</button>
	<button
		mat-raised-button
		*ngIf="onCancel"
		(click)="handleCancel()"
		[disabled]="isLoading"
	>
		{{ cancelLabel }}
	</button>
</div>
